import React from 'react';
import { Form, Card, Select, Button, Spin, Modal, Tag } from 'antd';
import { connect } from 'dva';
import { formItemLayout } from 'utils/utils.js';
import { debounce } from 'lodash-decorators';
import styles from './Index.less';

const FormItem = Form.Item;
const { Option } = Select;

const getFormatRelatedSchoolsFormData = ({ merchantSchool, schools }) => {
  const initialValue = {};

  if (merchantSchool) {
    initialValue.merchantSchool = {
      key: merchantSchool.id,
      label: merchantSchool.name,
    };
  }

  if (schools) {
    initialValue.schools = [];
    schools.forEach(school => {
      initialValue.schools.push({
        key: school.id,
        label: school.name,
      });
    });
  }

  return initialValue;
};

@connect(({ loading, operationMerchantAddOrUpdate }) => ({
  loadingMerchantSchools: loading.effects['operationMerchantAddOrUpdate/fetchMerchantSchools'],
  merchantSchools: operationMerchantAddOrUpdate.merchantSchools,

  loadingRelatedSchools: loading.effects['operationMerchantAddOrUpdate/fetchRelatedSchools'],
  relatedSchools: operationMerchantAddOrUpdate.relatedSchools,

  submitting: loading.effects['operationMerchantAddOrUpdate/addOrUpdateSchools'],
  relatedSchoolsFormData: operationMerchantAddOrUpdate.relatedSchoolsFormData,

  loading: loading.effects['operationMerchantAddOrUpdate/fetchRelatedSchoolsInfo'],

  merchantId: operationMerchantAddOrUpdate.merchantId,
}))
@Form.create()
export default class RelatedSchoolsInfo extends React.Component {
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDispatchSubmit = this.handleDispatchSubmit.bind(this);
    this.handleSearchMerchantSchools = this.handleSearchMerchantSchools.bind(this);
    this.handleSearchRelatedSchools = this.handleSearchRelatedSchools.bind(this);

    this.renderMerchantSchool = this.renderMerchantSchool.bind(this);
    this.renderSchools = this.renderSchools.bind(this);
  }

  componentDidMount() {
    const { form, relatedSchoolsFormData, merchantIdForEditOrQuery, type } = this.props;

    if (type === 'add') {
      const initialValue = getFormatRelatedSchoolsFormData(relatedSchoolsFormData);
      form.setFieldsValue(initialValue);
    } else if (type === 'edit' || type === 'query') {
      this.props.dispatch({
        type: 'operationMerchantAddOrUpdate/fetchRelatedSchoolsInfo',
        merchantId: merchantIdForEditOrQuery,
      });
    }
  }

  handleSubmit(e) {
    e.preventDefault();

    const { form } = this.props;

    form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        const message = [];
        if (!values.merchantSchool) {
          message.push('学校名称');
        }

        if (!values.schools) {
          message.push('商家关联学校');
        }

        if (message.length <= 1) {
          this.handleDispatchSubmit(values);
        } else {
          Modal.confirm({
            title: '确认',
            content: `未选择${message.join('、')}，确认继续提交？`,
            onOk: () => {
              this.handleDispatchSubmit(values);
            },
          });
        }
      }
    });
  }

  handleDispatchSubmit(values) {
    const { dispatch, successCallback, merchantId } = this.props;
    dispatch({
      type: 'operationMerchantAddOrUpdate/addOrUpdateSchools',
      merchantId,
      merchantSchool: values.merchantSchool,
      schools: values.schools,
    }).then(() => {
      if (successCallback) {
        successCallback();
      }
    });
  }

  @debounce(1000)
  handleSearchMerchantSchools(param) {
    if (!param) {
      return;
    }

    const { dispatch } = this.props;

    dispatch({
      type: 'operationMerchantAddOrUpdate/saveMerchantSchools',
      merchantSchools: [],
    });

    dispatch({
      type: 'operationMerchantAddOrUpdate/fetchMerchantSchools',
      param,
    });
  }

  @debounce(1000)
  handleSearchRelatedSchools(param) {
    if (!param) {
      return;
    }

    const { dispatch } = this.props;

    dispatch({
      type: 'operationMerchantAddOrUpdate/saveRelatedSchools',
      relatedSchools: [],
    });

    dispatch({
      type: 'operationMerchantAddOrUpdate/fetchRelatedSchools',
      param,
    });
  }

  renderMerchantSchool() {
    const { loadingMerchantSchools, merchantSchools, type, relatedSchoolsFormData } = this.props;

    if (type === 'query') {
      let merchantSchoolName = '无';
      if (relatedSchoolsFormData.merchantSchool) {
        merchantSchoolName = relatedSchoolsFormData.merchantSchool.name;
      }

      return <span>{merchantSchoolName}</span>;
    }

    return (
      <Select
        allowClear
        labelInValue
        showSearch
        placeholder="请选择"
        notFoundContent={loadingMerchantSchools ? <Spin size="small" /> : '请输入关键字进行搜索'}
        filterOption={false}
        onSearch={this.handleSearchMerchantSchools}
        disabled={type === 'query'}
      >
        {merchantSchools.map(school => <Option key={school.orgId}>{school.orgName}</Option>)}
      </Select>
    );
  }

  renderSchools() {
    const { loadingRelatedSchools, relatedSchools, type, relatedSchoolsFormData } = this.props;

    if (type === 'query') {
      const relatedSchoolsName = [];
      if (relatedSchoolsFormData.schools) {
        relatedSchoolsFormData.schools.forEach(school => {
          relatedSchoolsName.push(<Tag key={school.id}>{school.name}</Tag>);
        });
      }

      if (relatedSchoolsName.length === 0) {
        return <span>无</span>;
      }

      return <span>{relatedSchoolsName}</span>;
    }

    return (
      <Select
        mode="multiple"
        labelInValue
        placeholder="请选择"
        notFoundContent={loadingRelatedSchools ? <Spin size="small" /> : '请输入关键字进行搜索'}
        filterOption={false}
        onSearch={this.handleSearchRelatedSchools}
        disabled={type === 'query'}
      >
        {relatedSchools.map(school => <Option key={school.orgId}>{school.orgName}</Option>)}
      </Select>
    );
  }

  render() {
    const {
      className,
      cardTitle,
      submitText,
      submitLeftExtraActions,
      submitting,
      loading,
      type,
      relatedSchoolsFormData,
    } = this.props;
    const { getFieldDecorator } = this.props.form;
    const formatRelatedSchoolsFormData = getFormatRelatedSchoolsFormData(relatedSchoolsFormData);

    return (
      <Card
        bordered={false}
        className={`${styles.root} ${className}`}
        title={cardTitle}
        loading={loading}
      >
        <Form onSubmit={this.handleSubmit}>
          <FormItem {...formItemLayout} label="学校名称/School ID">
            {getFieldDecorator('merchantSchool', {
              initialValue: formatRelatedSchoolsFormData.merchantSchool,
            })(this.renderMerchantSchool())}
          </FormItem>

          <FormItem {...formItemLayout} label="商家关联学校">
            {getFieldDecorator('schools', {
              initialValue: formatRelatedSchoolsFormData.schools,
            })(this.renderSchools())}
          </FormItem>

          {type !== 'query' && (
            <FormItem className="operation-button-wrap">
              {submitLeftExtraActions}
              <Button type="primary" htmlType="submit" loading={submitting}>
                {submitText}
              </Button>
            </FormItem>
          )}
        </Form>
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/Operation/Merchant/components/RelatedSchoolsInfo/Index.js